import { useEffect } from "react";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { CURRENCIES, setCurrency, setRates, useCurrency } from "@/lib/currency";

export const CurrencySwitcher = ({ light, className = "" }) => {
  const { code, autoDetected } = useCurrency();
  useEffect(() => {
    fetch(`${API}/fx`)
      .then((r) => r.json())
      .then((d) => d?.rates && setRates(d.rates))
      .catch(() => {});
  }, []);
  useEffect(() => {
    if (autoDetected && code !== "USD" && !sessionStorage.getItem("pachamama.currency.hint")) {
      sessionStorage.setItem("pachamama.currency.hint", "1");
      const c = CURRENCIES.find((x) => x.code === code);
      toast(`Prices shown in ${c?.label || code}`, {
        description: "Detected from your location — change it anytime from the menu.",
      });
    }
  }, [autoDetected, code]);
  return (
    <label
      className={`relative inline-flex items-center ${className}`}
      title={autoDetected ? "Currency detected from your location" : "Currency"}
      data-testid={autoDetected ? "currency-auto-detected" : "currency-manual"}
    >
      <select
        value={code}
        onChange={(e) => setCurrency(e.target.value)}
        aria-label="Currency"
        data-testid="currency-select"
        className={`cursor-pointer appearance-none rounded-full border bg-transparent py-2 pl-3 pr-7 font-mono text-[11px] uppercase tracking-[0.2em] outline-none transition-colors ${
          light
            ? "border-cream/40 text-cream hover:bg-cream/10 [&>option]:bg-ink [&>option]:text-cream"
            : "border-pine/30 text-pine hover:bg-pine/5 [&>option]:bg-cream [&>option]:text-pine"
        }`}
      >
        {CURRENCIES.map((c) => (
          <option key={c.code} value={c.code}>
            {c.code}
          </option>
        ))}
      </select>
      <span className="pointer-events-none absolute right-2.5 text-[9px]">▾</span>
    </label>
  );
};
